// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockCodeButtons_wrapper__q1+jq","btn":"BlockCodeButtons_btn__nAhET"};